<template>
  <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumbs">
    <el-breadcrumb-item :to="localizedLink('home')">{{
      $t("breadcrumbs.home")
    }}</el-breadcrumb-item>
    <el-breadcrumb-item
      v-for="link in links"
      :key="link.name"
      :to="link.link ? localizedLink(link.link) : null"
      >{{ $t(`breadcrumbs.${link.name}`) }} {{ link.value }}</el-breadcrumb-item
    >
  </el-breadcrumb>
</template>

<script>
import { localizedLink } from "@/mixins";

export default {
  props: {
    links: Array,
    default: () => []
  },
  mixins: [localizedLink]
};
</script>

<style lang="scss" scoped>
.breadcrumbs {
  margin: 8px 0;
  padding: 0;
  @include media("<navbar-sm") {
    display: none;
  }
}

.el-breadcrumb__item {
  font-size: rem(14);
  text-transform: uppercase;

  ::v-deep {
    .el-breadcrumb__inner {
      &.is-link {
        font-weight: 400;
        color: inherit;
        &:hover {
          color: $--text-primary;
          text-decoration: underline;
        }
      }
    }

    .el-breadcrumb__separator {
      font-weight: 700;
      color: inherit;
    }
  }
}
</style>
